/**
 * LaunchDarkly gate for the plugin Version Management tab on the Plugin Detail
 * page. LD key: `om_tech_23847_version_management_tab`; the React SDK camelCases
 * flag keys, so call sites read the camelCase form.
 *
 * The tab is additionally gated on the caller's authority over this plugin —
 * an admin, or a vendor holding `integration:plugins_create` who owns the
 * Vendor-type plugin (mirroring the connections-list endpoint's
 * `ValidateVendorPluginAccess`). The flag and that authority must BOTH be
 * satisfied for the tab to show. The backend read the tab consumes
 * (`.../version?includeDistribution`) is NOT gated by this flag; it stays
 * reachable under its existing `Plugins.Get` policy. This flag governs the
 * portal surface only.
 *
 * Default OFF: every environment resolves to off until targeting flips it.
 */
export const VERSION_MANAGEMENT_FLAG = 'omTech23847VersionManagementTab';
export const VERSION_MANAGEMENT_FLAG_DEFAULT = false;

/**
 * LaunchDarkly gate for the merchant-migration CTAs in the Version Management
 * selection bar (target-version select, Migrate, Review Custom Mappings). Those
 * actions are wired by the next epic; until it ships the whole selection bar is
 * hidden so a selection never surfaces controls that do nothing. LD key:
 * `om_tech_23848_merchant_migration`; read as camelCase.
 *
 * Default OFF: every environment resolves to off until the migration epic flips it.
 */
export const MERCHANT_MIGRATION_FLAG = 'omTech23848MerchantMigration';
export const MERCHANT_MIGRATION_FLAG_DEFAULT = false;
